// extracted by mini-css-extract-plugin
export default {"overlay":"uv-z","bodyOpen":"vv-z","content":"wv-z","header":"xv-z","close":"yv-z","closeNoHeading":"zv-z"};